import { ActivityMap } from './activity.action';

const initialActivityState = {
    userActivities: [],
    selectedUser: {},
    singleModal: false,
    multiModal: false,
    refreshActivities: true,
    isLoading: false
}

export const reducer = (state = initialActivityState, action) => {
    switch (action.type) {
        case ActivityMap.FETCH_ACTIVITY_START:
        case ActivityMap.MULTIPLE_ACTIVITY_DELETE_START: {
            return {
                ...state
            }
        }
        case ActivityMap.OPEN_SINGLE_MODAL: {
            return {
                ...state,
                singleModal: true
            }
        }
        case ActivityMap.OPEN_MULTIPLE_MODAL: {
            return {
                ...state,
                multiModal: true
            }
        }
        case ActivityMap.CLOSE_SINGLE_MODAL: {
            return {
                ...state,
                singleModal: false
            }
        }
        case ActivityMap.CLOSE_MULTIPLE_MODAL: {
            return {
                ...state,
                multiModal: false
            }
        }
        case ActivityMap.FETCH_ACTIVITY_SUCCESS: {
            return {
                ...state,
                userActivities: action.payload,
                refreshActivities: false
            }
        }
        case ActivityMap.SINGLE_ACTIVITY_DELETE_START: {
            return {
                ...state,
                singleModal: true,
                isLoading: true,
            }
        }
        case ActivityMap.SINGLE_ACTIVITY_DELETE_SUCCESS: {
            return {
                ...state,
                singleModal: false,
                userActivities: action.payload,
                isLoading: false
            }
        }
        case ActivityMap.SINGLE_ACTIVITY_DELETE_FAIL: {
            return {
                ...state,
                singleModal: false,
                isLoading: false
            }
        }
        case ActivityMap.MULTIPLE_ACTIVITY_DELETE_SUCCESS:{
            return {
                ...state,
                multiModal: false,
                userActivities: action.payload,
                isLoading: false
            }
        }
        case ActivityMap.MULTIPLE_ACTIVITY_DELETE_FAIL:
            {
                return {
                    ...state,
                    multiModal: false,
                    isLoading: false
                }
            }
        default: return { ...state }
    }
}